import { fetchOperation, getOperation, fetchMaster } from "utils/api";

export const queryStatementList = async (params) => {
  return await getOperation("/statement/list", {
    ...params,
  });
};

export const queryMerchantOptions = async (params) => {
  return await getOperation("/merchant/options", {
    page: 0,
    size: 500,
    ...params,
  });
};

export const showStatementPdf = async (params) => {
  return await fetchOperation("/statement/presign", {
    ...params,
  });
};

export const generateStatementPdf = async (params) => {
  return await fetchMaster("/statement/pdf-generate", {
    ...params,
  });
};
